import React from 'react'

import './HashtagFilter.css'

const getHashtags = (items) => {
  let hashtags = new Set([])

  items.forEach(item => {
    if (!item.isDone) {
      let results = item.content.match(/#\w+/ig)
      if (results) {
        results.forEach(result => hashtags.add(result.toLowerCase()))
      }
    }
  })

  return Array.from(hashtags)
}

class HashtagFilter extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      selectedFilter: ''
    }
  }

  render() {

    const hashtags = getHashtags(this.props.globalState.todos)

    return(
      <div className="hashtagContainer">
        {
          this.props.globalState.textFilter
            ? (<div style={this.props.globalState.textFilter
                  ? {display: 'flex', backgroundColor: 'dodgerblue', opacity: '0.8', padding: '1em', width: '100%'}
                  : {display: 'none'}
                }>
                <div>Only looking at to-dos that contain "{this.props.globalState.textFilter}"</div>
                <button style={{border: 'none', margin: '0 1em'}} onClick={() => this.props.actions.textSearch('')} >Clear</button>
              </div>)
            : hashtags.length
                ? <React.Fragment>
                    {hashtags.map( (hashtag, index) => <button className="hashtag" key={index} onClick={() => this.props.actions.textSearch(hashtag)}>{hashtag}</button> )}
                  </React.Fragment>
                : <div className="hashtag-promotions">Try hashtags like <span className="example">#buy shampoo from #target</span> to quickly find stuff later.</div>
        }
      </div>
    )
  }


}

export default HashtagFilter



// WEBPACK FOOTER //
// ./src/components/HashtagFilter.js